import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountElementService } from 'app/core/services/account-element.service';
import { RefreshElementService } from 'app/core/services/refresh-element/refresh-element.service';

@Component({
  selector: 'dialog-delete-element',
  templateUrl: './dialog-delete-element.component.html',
  styleUrls: ['./dialog-delete-element.component.scss']
})
export class DialogDeleteElementComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteElementComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private accountElementService: AccountElementService, private refreshElement: RefreshElementService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteElement() {
    this.isLoading = true;
    this.accountElementService.deleteElement(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshElement.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}
